<template>
  <div v-if="loaded">
    <q-dialog
        v-model="errorDialog"
        position="top">
      <q-card
          style="max-width: 70vw;max-height: 90vh"
          class="bg-warning text-white">
        <el-row
            v-for="(err, idx) in errors"
            :key="idx">
          <pre>{{ err }}</pre>
        </el-row>
      </q-card>
    </q-dialog>
    <sc-panel-navigator
        @update="updateTrip"
        @delete="removeTrip"
        :drawerWidth="400"
        v-loading="buzy"
        element-loading-text="processing..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :key="clock">
      <!-- cl{{clock}} -->
      <el-card>
        <el-row
            slot="header"
            class="clearfix dark-header">
          <el-col :md="24">
            <!--                        -=-=          {{workingTripTypes}}-->

            <ctk-dater
                range
                :key="$route.path"
                v-model="bookingRange"
                display-format="dd/MM/yyyy"
                export-format="DD/MM/YYYY"
                valueFormat="onurl"
                default="2months"
             ></ctk-dater>
          </el-col>
          <el-col :span="24" style="padding: 5px" v-if="!$route.query.hs">
            <TripTypeSelector v-model="workingTripTypes"/>
          </el-col>
          <el-col :span="20">
            <q-input clearable v-model="search" label="search by name or reference" :debounce="800" dark :dense="true"/>
            <s-remote-select
                dark
                style="width: 100%"
                v-model="tourcoselect"
                class-model="tourcompany"
                query-prop="q"
                :multiple="true"
                :extraQueryParams="{bookingRange:bookingRange,workingTripTypes:workingTripTypes}"
                label-prop="coname"
                placeholder="Company search..."></s-remote-select>
            <s-remote-select
                dark
                style="width: 100%"
                :extraQueryParams="{
                    labelField: 'distributor',
                    limit: 0,
                    companyId:tourcoselect,
                    action: 'booking/getoptions',
                    valueField: 'distributor',
                  }"
                v-model="distributor_select"
                fetchProcessor="booking/getoptions"
                query-prop="query"
                :multiple="true"
                label-prop="distributor"
                value-prop="distributor"
                :placeholder="'Search for distributor'"></s-remote-select>
            <s-remote-select
                v-if="workingKind=='EXCRS'||workingKind=='PACKAGE'"
                dark
                style="width: 100%"
                :extraQueryParams="{ kind: $route.params.kind, options: 'title' }"
                v-model="tripselect"
                class-model="tripservice"
                query-prop="search"
                label-prop="title"
                :placeholder="'Search for ' + workingKind"></s-remote-select>
            <!--            <ScInput v-model="search" />-->
          </el-col>
          <el-col :span="4">
            <sf-button
                title="Create new scheduled trip (flight, excursion....)"
                plain
                type="success"
                style="float: right"
                @click="goToTrip('new')">
              <fa
                  icon="plus"
                  fixed-width></fa>

            </sf-button>
            <q-fab
                :label="selectedBookings && selectedBookings.length
                  ? selectedBookings.length
                  : null"
                style="float: right"
                color="secondary"
                push
                icon="build"
                direction="down"
                v-if="workingKind != 'PACKAGE'"
                square>
              <q-fab-action
                  v-if="selectedBookings && selectedBookings.length"
                  color="warning"
                  @click="setStore({storename: 'selectedBookings',data: null});++clock"
                  square
                  external-label
                  icon="close"
                  label="Clear selection"
                  label-position="left"/>
              <q-fab-action
                  color="primary"
                  @click="moveMode = !moveMode"
                  square
                  external-label
                  :disable="!getStoreValues('selectedBookings')"
                  icon="open_with"
                  :label="
                  moveMode ? 'Dont move bookings' : 'Move selected bookings'
                "
                  label-position="left"/>
              <q-fab-action
                  square
                  external-label

                  label="Issue Invoices/API"
                  label-position="left"
                  color="accent"
                  @click="issueDialog()"
                  icon="receipt"/>


              <q-fab-action
                  square
                  external-label
                  label="Bookings Excel"
                  label-position="left"
                  color="green"
                  @click="getExcel('bookings_list')"
                  icon="recent_actors"/>
              <q-fab-action
                  square
                  v-if="workingKind != 'EXCRS'"
                  external-label
                  label="Calc Prices"
                  label-position="left"
                  color="accent"
                  @click="calcPrices()"
                  icon="functions"/>
              <q-fab-action
                  square
                  v-else-if="userDomain == 'travel'"
                  external-label
                  label="Calc Prices"
                  label-position="left"
                  color="accent"
                  @click="calcPrices('EXCRS')"
                  icon="functions"/>
              <q-fab-action
                  square
                  v-if="workingKind != 'EXCRS' && userDomain == 'travel2'"
                  external-label
                  label="update SunWeb"
                  label-position="left"
                  color="accent"
                  @click="updateSunWeb()"
                  icon="send"/>
              <q-fab-action
                  square
                  external-label
                  label="Ac. Excel"
                  label-position="left"
                  color="accent"
                  @click="getExcel()"
                  icon="insert_chart"/>
            </q-fab>
          </el-col>


        </el-row>

        <div>
          <s-table
              :key="bookingRange ? bookingRange[0] + bookingRange[1] : 0"
              ref="tripsList"
              vxif="bookingRange.length"
              :colDefinitions="colTripDefinitions"
              modx-processor="scheduletrip/getlist"
              :row-class-factory="rowStyler"
              :r-query="qTrips"
              @cell-clicked="goToTrip"></s-table>
        </div>
      </el-card>
      <q-dialog
          v-model="invDialog"


          maximized
          full-height
          transition-show="slide-up"
          transition-hide="slide-down">
        <invoiceManagerPanel
            v-if="invDialog"
            @done="setStore({storename: 'selectedBookings',data: null});invDialog=false;++clock"
            @reload="++clock"
            :selectedBookings="selectedBookings"
            :working-kind="workingKind"/>
        <!--        </div >-->
      </q-dialog>
    </sc-panel-navigator>
  </div>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";
import commons from "~/mixins/commons";

import printHtml from "~/mixins/printHtml";
import SfButton from "../../Form/SfButton";
import CtkDater from "../../Form/ctkDatepicker";
import InvoiceManagerPanel from "./InvoiceManagerPanel";
import ScInput from "./ScInput";
import BookingsSelector from "../../Form/BookingsSelector.vue";
import TripTypeSelector from "./TripTypeSelector.vue";

export default {
  components: {TripTypeSelector, InvoiceManagerPanel, CtkDater, SfButton},
  mixins: [printHtml,
    commons],
  // props:{
  //   displayTripSelector:{type:Boolean,default: true},
  // },
  data() {
    return {
      displayTripSelector:true,
      tripOptions: [{
        value: 'DEP',
        // label: 'DEP',
        icon: 'flight_takeoff',
        color: 'red-6'
      },
        {

          value: 'ARV',
          color: 'orange-6',
          // label: 'ARV',
          icon: 'flight_land'
        },
        {
          color: 'teal-6',
          // label: 'ARV+DEP',
          value: 'ARVDEP',
          icon: 'flight'
        },
        {
          value: 'EXCRS',
          // label: 'EXCRS',
          icon: 'kayaking',
          color: 'teal-6'
        },
        {
          value: 'PICKUP',
          // label: 'PkP',
          icon: 'airport_shuttle',
          color: 'teal-6'
        }
      ],
      invDialog: false,
      moveMode: false,
      printData: null,
      printReady: false,
      loaded: false,
      timelineView: false,
      errors: null,
      errorDialog: false,
      page: 1,
      buzy: false,
      dbgIssue: null,
      // search: null,
      tripselect: null,
      // distributor_select:null,
      clock: 0,
      // bookingRange: [],

      cols: {},
      dateFormat: "DD/MM/YY",
    };
  },
  methods: {
    getExcel(type) {

      // let qBookings = {
      //   "Booking.tripid:=": this.$route.params.tripid,
      // };
      // if (this.$route.params.distributor_select)
      //   qBookings[
      //       "Booking.distributor:IN"
      //       ] = this.$route.params.distributor_select.split(",");

      // const url = "transdrafts/multigetlist", dQ = {
      //   limit: 0,
      //   start: 0,
      //   download: 1,
      //   selects: ["Booking.distributor as distributor"],
      //   q_conditions: JSON.stringify(qBookings),
      // };

      // <button controller="" class="btn btn-raised btn-primary ajaxified" action="tourcompany/getbookings" target="_blank" extra-params="daterange=11/09/2019 - 13/09/2019,tourcoid=28,download=1,limit=0" objectid="" data-json-selector="results" style="float: right;"><i class="material-icons">location_city</i><i class="material-icons">file_download</i></button>

      if (this.$route.params.kind == 'excrs' || type == 'bookings_list') {
        let Q = {
          range: this.bookingRange,
          tourcoselect: this.tourcoselect,
          distributors: this.distributor_select,
          tripid: this.$route.params.tripid != 'all' ? this.$route.params.tripid : null,
          download: this.$route.params.kind == 'excrs' ? 'excrs' : 'transfers',
          tripTypes: this.$route.params.kind,//'EXCRS',
          booking_status: this.$route.query.booking_status,
          invoice_status: this.$route.query.invoice_status
        }
        api.ajax_download("vue_booking/getlist", Q);
      } else {
        let Q = {
          daterange: this.bookingRange,
          tourcoid: this.tourcoselect,
          download: 1,
          booking_status: this.$route.query.booking_status,
          invoice_status: this.$route.query.invoice_status
        }
        api.ajax_download("tourcompany/getbookings", Q);
      }
    },
    rowStyler(r) {
      if (!r.row.paxData) return;
      // r;
      let cls = "",
          paxdata = r.row.paxData;
      if (paxdata.locked_count == paxdata.total_count) cls += "row-freezed";
      if (r.row.execstatus != 'normal') cls += " row-canceled";
      if (this.moveMode) cls += " drop-row";
      // _log_("row style....", cls, r.row.paxData);
      return cls;
    },
    async calcPrices(tripTypes) {
      this.buzy = true
      let q = {
        tripTypes: tripTypes || "ARV,DEP",
        ...this.$route.query,
        limit: 0,
        parseIds: this.selectedBookingIds,
        forceCalcPrices: true,
      };
      _log_("issueInvoices.0..", this.$route.query.query, q);
      if (this.bookingRange) q.range = this.bookingRange;
      if (this.$route.params.tripid) q.tripid = this.$route.params.tripid;
      // if (this.$route.query.query) q.customerSearchcustomerSearch = this.$route.query.query;
      const {data} = await api.fetchProcessor("vue_booking/getlist", q);
      // this.selectedBookings = null;
      ++this.clock;
      this.buzy = false
      _log_("issueInvoices...", this.$route.query.query, q, data);
    },
    async issueDialog() {
      // await this.issueInvoices(false, true)
      // await this.issueInvoices(true, true)
      this.invDialog = true

    },


    async updateSunWeb() {
      // var { data } = await api.fetchProcessor("gate/sunwebgate", {
      //   limit: 0
      // });
      // _log_("updateSunWeb...", data);
      this.errors = []
      let q = {
        tripTypes: "ARV,DEP",
        ...this.$route.query,
        limit: 0,
        report: "SunWeb",
        parseIds: this.selectedBookingIds,
      };

      if (this.bookingRange) q.range = this.bookingRange;
      if (this.$route.params.tripid) q.tripid = this.$route.params.tripid;
      // if (this.$route.query.query) q.customerSearch = this.$route.query.query;
      const {data} = await api.fetchProcessor("vue_booking/getlist", q);
      _log_("issueInvoices.0..", data);
      if (
          data &&
          data.message &&
          data.message.errors &&
          data.message.errors.length
      ) {
        this.errors = data.message.errors;
        this.errorDialog = true;
      } else {
        const vm = this
        _log_('data.results', data)
        data.results.forEach(r => {
          vm.errors.push(r)
        })
        if (vm.errors.length) this.errorDialog = true;
      }
      ++this.clock;
    },
    updateTrip(e) {
      _log_("trip update..", e);
      // reloadRowModx;
      // this.$refs.tripsList.updateOrAppendRow(e);
      this.$refs.tripsList.reloadRowOrAppend(e);
    },
    removeTrip(payload) {
      this.routeGo({name: "tripsmanager", params: this.$route.params});
      this.$refs.tripsList.reload();
      // this.$refs.tripsList.removeRow(payload);
    },
    async goPrintThis() {
      var {data} = await api.fetchProcessor("bookings/vuebookings", {
        "bookingRange[]": this.bookingRange,

        tripselect: this.tripselect,
        distributor: this.distributor_select,
        limit: 0,
      });
      this.printData = data.results;
      this.printReady = true;
    },
    alert(msg) {
      _log_("hell...", msg, this.bookingRangeA.getTime());
    },

    newBooking() {
      // _log_("gooooo");
      this.routeGo({
        name: "EditBooking",
        query: {bkid: "new"},
      });
    },
    ...mapActions({
      fetchRooms: "hotelinfo/fetchRooms",
    }),
    ...mapMutations({
      setStore: "helpers/setStore",
      toggleSelection: "helpers/toggleSelection",
    }),
    async goToTrip(data) {
      let pendingMoves = this.getStoreValues("selectedBookings");
      if (this.moveMode && pendingMoves && pendingMoves.length) {
        this.$confirm(
            "Do you want to move selected bookings to " +
            data.row.tripName +
            " on " +
            this.formatDate(data.row.time) +
            "?",
            "Warning",
            {
              confirmButtonText: "Yes move them",
              cancelButtonText: "No just let me inspect the trip",
              type: "warning",
            }
        )
            .then(async () => {
              _log_("set..MOVE.", pendingMoves);
              let selectedBookings = [],
                  affectedTrips = [data.row.id];
              if (pendingMoves[0].controller) {
                pendingMoves = await api.getModxList(pendingMoves[0].controller, {
                  ...pendingMoves[0].queryParams,
                  limit: 0
                })
              }
              pendingMoves.forEach((bk) => {
                selectedBookings.push(bk.id);
                if (!affectedTrips.includes(bk.tripid))
                  affectedTrips.push(bk.tripid);
              });
              const resp = await api.fetchProcessor("booking/fullupdate", {
                do: "changeTrip",
                bkids: selectedBookings.join(","),
                tripid: data.row.id,
              });
              affectedTrips.forEach((element) => {
                this.$refs.tripsList.reloadRow(element);
              });

              this.setStore({
                storename: "selectedBookings",
                data: null,
              });
              _log_("RR..MOVE.", data);
              this.routeGo({
                name: "tripBookings",
                params: {tripid: data.row.id},
              });
            })
            .catch(() => {
              this.setStore({
                storename: "selectedBookings",
                data: null,
              });
              this.routeGo({
                name: "tripBookings",
                params: {tripid: data.row.id},
              });
            });

        return;
      } else {
        this.toggleLefPanelResponsive(false)
        if (data == "new")
          this.routeGo({
            name: "configureScheduledTrip",
            params: {tripid: "new"},
          });
        else {
          if (this.$route.params.kind == "package")
            this.routeGo({
              name: "customers",
              params: {tripid: data.row ? data.row.id : data},
            });
          else
            this.routeGo({
              name: "tripBookings",
              params: {tripid: data.row ? data.row.id : data},
            });
        }
      }
    },
  },
  async mounted() {
    const date = new Date();
    const user = await this.getLoggedUser()
    _log_("the user", user);
    //  [
    //   date.getTime(),
    //   date.getTime() + 3600 * 1000 * 24 * 91
    // ];
    // _log_("TRIPS..w.", st, this.bookingRange, this.$route);

    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  watch: {
    selectedBookings(val, oldval) {
      if (!val || !val.length) {
        this.moveMode = false;
      }
      _log_("the rs/getStore//", val, oldval);
    },
    // "$route": {
    //   handler(val, oldval) {
    //     _log_("the rs///", val, oldval);
    //     // if (val != oldval && (val == "tripsmanager" || val == "tripBookings")) {
    //     //   const st = dateHelper.format(
    //     //       dateHelper.startOfWeek(new Date()),
    //     //       "DD/MM/YYYY"
    //     //     ),
    //     //     ed = dateHelper.format(
    //     //       dateHelper.endOfWeek(new Date()),
    //     //       "DD/MM/YYYY"
    //     //     );
    //     //   if (!this.bookingRange) {
    //     //     this.bookingRange = [st, ed];
    //     //   }
    //     // }
    //   },
    //   immediate: true,
    // },
  },
  computed: {

    tourcoselect: {
      get() {
        return this.$route.query.tourcoselect
            ? this.$route.query.tourcoselect
            : null;
      },
      set(v) {
        this.routeGo({query: {tourcoselect: v}});
      },
    },
    invoice_status: {
      get() {
        return this.$route.query.invoice_status
            ? this.$route.query.invoice_status
            : "all";
      },
      set(v) {
        this.routeGo({query: {invoice_status: v}});
      },
    },
    booking_status: {
      get() {
        return this.$route.query.booking_status
            ? this.$route.query.booking_status
            : "all";
      },
      set(v) {
        this.routeGo({query: {booking_status: v}});
      },
    },
    search: {
      get() {
        return this.$route.query.query;
      },
      set(v) {
        const y = (new Date()).getFullYear()
        this.routeGo({
          params: {tripid: 'all'},
          query: {query: v, timerange_from: '1/1/' + y, timerange_to: '1/1/' + (y + 1)}
        }, true)
      },
    },
    distributor_select: {
      set(v) {
        _log_("go ahead/bookingRange/", v);
        // if (this.loading) return;
        let q = JSON.parse(JSON.stringify(this.$route.query));
        if (!v) {
          q.distributor_select = null;
        }
        q.distributor_select = _.isArray(v) ? v.join(',') : v;

        this.routeGo(
            {
              query: q,
            },
            true
        );

        return;
      },
      get() {
        return this.$route.query.distributor_select
            ? this.$route.query.distributor_select
            : null;
      },
    },
    selectedBookings() {
      return this.getStoreValues("selectedBookings")
      // return this.$store.state.helpers.general_store.selectedBookings
      const Vals = this.$store.state.helpers.general_store.selectedBookings//this.getStore("selectedBookings");
      // _log_('yelllo,', Vals)
      return Vals// Object.values(Vals?Vals:{});
    },
    selectedBookingIds() {
      let selectedBookings = [];

      const pendingMoves = this.selectedBookings;
      if (pendingMoves && pendingMoves.length) {
        pendingMoves.forEach((bk) => {
          if (bk && bk.id && bk.id != "") {
            selectedBookings.push(bk.id);
          }
        });
      } else return null;
      return selectedBookings;
    },
    selectedNormalBookingIds() {
      let selectedBookings = [];

      const pendingMoves = this.selectedBookings;
      if (pendingMoves && pendingMoves.length) {
        pendingMoves.forEach((bk) => {
          if (
              bk &&
              bk.id &&
              bk.id != "" &&
              bk.execStatus != "canceled" &&
              bk.status == "normal"
          ) {
            selectedBookings.push(bk.id);
          }
        });
      } else return null;
      return selectedBookings;
    },
    workingTripTypes: {
      get() {
        _log_("the main params...", this.$route.params);

        if (!this.$route.params.kind) {
          console.error("Route corrupted, no trip kind specified");
          return;
        }
        return this.$route.params.kind.toUpperCase()
        // .split(',');
      },
      set(v) {
        if (!v) return
        if (!v.length) return
        this.routeGo({params: {kind: v && _.isArray(v) ? v.join(',') : v}})
      }
    },
    workingKind() {
      _log_("the main params...", this.$route.params);

      if (!this.$route.params.kind) {
        console.error("Route corrupted, no trip kind specified");
        return;
      }
      return this.$route.params.kind.toUpperCase();
    },
    ...mapGetters({
      getStore: "helpers/getStore",
      getStoreValues: "helpers/getStoreValues",
    }),

    // qBookings() {
    //   return { "bookingRange[]": bookingRange, tripselect: tripselect };
    // },
    qTrips() {
      _log_(">>Q>>", this.tripselect);
      var q = {};
      if (this.bookingRange)
        q = {
          daterange:
              (this.bookingRange[0] ? this.bookingRange[0] : "") +
              "-" +
              (this.bookingRange[1] ? this.bookingRange[1] : ""),

          // tripType: this.workingKind
        };
      if (this.tourcoselect) q['cooptions'] = this.tourcoselect
      if (this.tripselect) q["excrsid"] = this.tripselect;
      if(this.distributor_select) q["distributors"] = this.distributor_select;
      if (this.search) q['bookingsearch'] = this.search
      // if (this.$route.query.query) q.bookingsearch = this.$route.query.query;
      q.tripTypes = this.workingKind;
      q.sort = 'time'
      q.dir = 'asc'
      _log_(">>QP>>", q);
      return q;
    },
    colTripDefinitions() {
      var rw = "580px";
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        // {
        //   prop: "paymentStatus",
        //   width: "120px",
        //   label: "Πληρωμή",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-payment"
        //   }
        // },
        {
          prop: "tripName", width: "", label: "Trip",

          formatter(val, cols, dataContext) {
            //return;
            let rtn = dataContext.tripName;

            // _log_('???' + value, dataContext)
            if (dataContext != undefined) {

              if (dataContext.tripType == "DEP") {
                rtn +=
                    '<i class="label label-warning smicon material-icons">flight_takeoff</i>'
              } else if (dataContext.tripType == "ARV") {
                rtn +=
                    '<i class="label label-success smicon material-icons">flight_land</i>'
              } else rtn += '<i class="material-icons">location_city</i>';
              if (dataContext.status == "normal")
                rtn = '<i class="material-icons smicon">check</i>' + rtn;
            }
            //        rtn += ' ' + dataContext.humanDate;
            return rtn;
          },
        },
        {
          prop: "time",
          width: "120px",
          label: "Date",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatDate(val) + '<small>.' + row.humantime + '</small>';
          },
        },

        // {
        //   prop: "timetime",
        //   width: "",
        //   label: "Time",
        //   formatter: function(val, colDefs, row, vm) {
        //     return vm.formatUnxTime(row.time, true);
        //   }
        // },
        {
          prop: "paxData",
          width: "80px",
          label: "PAX",
          formatter: function (val, cols, row) {
            if (!val) {
              if (!row.adultspax && !row.canceled) return "";
              let pcpax = row.canceled
                  ? '<span style="font-size:10px;color:red" title="total pax">' +
                  row.canceled +
                  "</span>"
                  : "";
              return (
                  pcpax + '<span style="font-weight:bold">' + row.pax + "</span>"
              );
            }
            let pax = val.pax ? val.pax : row.pax,
                cpax = ''
            cpax += '<span class="label-info" title="Pax to be transferred">' + (row.paxData && row.paxData.transferPax ? row.paxData.transferPax : 0)
            cpax += '<span class="material-icons" >' +
                'directions_bus' +
                '</span></span>'
            cpax += val.canceledPax
                ? '<span class="small_note" style="font-size:10px;background-color:red;color:white" title="canceled pax">' +
                val.canceledPax +
                "</span>"
                : "";
            cpax += val.overbookedpax
                ? '<span class="small_note" style="font-size:10px;background-color:orange" title="overboked pax">' +
                val.overbookedpax +
                "</span>"
                : "";
            // if (row.paxData) {
            //   if (row.paxData.total_count)
            //     cpax +=
            //         '<span class="small_note" title="bookings/pax">' +
            //         row.paxData.total_count +
            //         "</span>";

            // if (row.paxData.own_count)
            //   cpax +=
            //     '<span class="small_note important" title="total bookings by you">' +
            //     row.paxData.own_count +
            //     "</span>";
            // }

            // _log_(">>paxData>>", val, row);
            return pax
                ? cpax +
                '<span  class="label-primary" title="total pax Adults:' +
                row.paxData.adultspax +
                " Kids:" +
                row.paxData.kidspax +
                '">' +
                pax +
                "</span>"
                : cpax;
          },
        },
        // {
        //   prop: "roomsF",
        //   width: rw,
        //   label: "Κράτηση",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-rooms"
        //   }
        // }
      ];
    },
  },
};
</script>

<style>
tr.el-table__row.drop-row {
  cursor: grabbing;
}

tr.el-table__row.drop-row td {
  border: 1px dotted;
}

.q-btn--fab .q-btn__wrapper {
  min-height: 35px;
  min-width: 35px;
}

.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}

.row-canceled {
  text-decoration: line-through;
}
</style>
